<template>
  <div>
    <validation-observer ref="feeReminderRules">
      <b-form>
        <b-row>
          <b-col
            sm="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Reminder fee"
              rules="required|reminder"
            >
              <b-form-group
                :label="$t('DEBTIA_REMINDER_FEE')"
                label-for="reminderFee"
              >
                <b-form-input
                  v-model="reminderFee"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Fee"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            cols="12"
          >
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="validationReminderFeeForm"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BFormInput,
  BButton,
  BForm,
  BRow,
  BCol,
  // BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import { required, reminder } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    // BInputGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      reminder,
      reminderFee: 0,
      validateFee: true,
    }
  },
  created() {
  },
  methods: {
    async validationReminderFeeForm() {
      // console.log('in await creation this.conditionObject.parentID, ', this.conditionObject.parentID)
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 7,
        module_order: 1,
        reminder_fee: Number(this.reminderFee),
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      await this.$refs.feeReminderRules.validate().then(success => {
        if (success) {
          axios.post('/process/module/fee-validation', {
            process_id: Number(processID),
            fee_amount: Number(this.reminderFee),
          }).then(() => {
            this.validateFee = true
            const url = '/process/module/add'
            axios.post(url, dataObj).then(response => {
              if (response.status === 200) {
                this.reminderFee = 0
                const returnObj = {
                  parentID: this.conditionObject.parentID,
                  depend: dataObj.depends_on,
                }
                returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
                this.$emit('closeReminderFeeModal', returnObj)
              }
            }).catch(e => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Error',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: e.response.data.message[0],
                },
              })
            })
          }).catch(e => {
            this.validateFee = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: e.response.data.message,
              },
            })
            // return false
          })
          /* console.log(this.validateFee)
          if (!this.validateFee) {
            console.log('fee not validated')
            return
          } */
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }
</style>
